import React from 'react';

export default function PrayerRequestForm(props){
  return(
    <div>
      <h1>How may we pray for you?</h1>
      <form className="prayRequestForm" onSubmit={props.handleSubmit}>
        <label htmlFor="name">Name</label><br/>
         <input type='text' id='name' value={props.formInputs.name} onChange={props.handleChange} /><br/>
         <label htmlFor="state">State</label><br/>
         <select name="State" id="state" value={props.formInputs.state} onChange={props.handleChange}>
           <option value="--">--</option> 
           <option id="state" value="Alabama">AL</option>
           <option id="state" value="Alaska">AK</option>
           <option id="state" value="Arizona">AZ</option>
           <option id="state" value="Arkansas">AR</option>
           <option id="state" value="California">CA</option>
           <option id="state" value="Colorado">CO</option>
           <option id="state" value="Connecticut">CT</option>
           <option id="state" value="Delaware">DE</option>
           <option id="state" value="Florida">FL</option>
           <option id="state" value="Georgia">GA</option>
           <option id="state" value="Hawaii">HI</option>
           <option id="state" value="Idaho">ID</option>
           <option id="state" value="Illinois">IL</option>
           <option id="state" value="Indiana">IN</option>
           <option id="state" value="Iowa">IA</option>
           <option id="state" value="Kansas">KS</option>
           <option id="state" value="Kentucky">KY</option>
           <option id="state" value="Louisiana">LA</option>
           <option id="state" value="Maine">ME</option>
           <option id="state" value="Maryland">MD</option>
           <option id="state" value="Massachusetts">MA</option>
           <option id="state" value="Michicgan">MI</option>
           <option id="state" value="Minnesota">MN</option>
           <option id="state" value="Mississippi">MS</option>
           <option id="state" value="Missouri">MO</option>
           <option id="state" value="Montana">MT</option>
           <option id="state" value="Nebraska">NE</option>
           <option id="state" value="Nevada">NV</option>
           <option id="state" value="New Hampshire">NH</option>
           <option id="state" value="New Jersey">MJ</option>
           <option id="state" value="New Mexico">NM</option>
           <option id="state" value="New York">NY</option>
           <option id="state" value="North Carolina">NC</option>
           <option id="state" value="North Dakota">ND</option>
           <option id="state" value="Ohio">OH</option>
           <option id="state" value="Oklahoma">OK</option>
           <option id="state" value="Oregon">OR</option>
           <option id="state" value="Pennsylvania">PA</option>
           <option id="state" value="Rhode Island">RI</option>
           <option id="state" value="South Carolina">SC</option>
           <option id="state" value="South Dakota">SD</option>
           <option id="state" value="Tennessee">TN</option>
           <option id="state" value="Texas">TX</option>
           <option id="state" value="Utah">UT</option>
           <option id="state" value="Vermont">VT</option>
           <option id="state" value="Virginia">VA</option>
           <option id="state" value="Washington">WA</option>
           <option id="state" value="West Virginia">WV</option>
           <option id="state" value="Wisconsin">WI</option>
           <option id="state" value="Wyoming">WY</option>
           <option id="state" value="District of Columbia">DC</option>
         </select><br/>
         <label htmlFor="Temptation">What is your primary temptation or struggle?</label><br/>
         <select name="Temptation" id="temptation" value={props.formInputs.temptation} onChange={props.handleChange}>
           <option>Please Select</option>
           <option id="temptation" value="Pornography/Lust">Pornography/Lust</option>
           <option id="temptation" value="Alcohol Abuse">Alcohol Abuse</option>
           <option id="temptation" value="Drug Abuse">Drug Abuse</option>
           <option id="temptation" value="Tobacco Abuse">Tobacco Abuse</option>
           <option id="temptation" value="Physical Illness">Physical Illness</option>
           <option id="temptation" value="Mental Illness">Mental Illness</option>
         </select><br/>
         <label htmlFor="Submit"></label>
         <input type="submit" value="Submit" />
      </form>
    </div>
  )
};

